<template>
    <div>
        <table
            class="table nowrap"
            id="ips" style="width:100% !important">
            <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col">IP</th>
                <th scope="col">Ping</th>
                <th scope="col">Server</th>
                <th scope="col">Domains</th>
                <th scope="col">Http Status</th>
                <th scope="col">SSL</th>
                <th scope="col">Orders</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(ip, i) in ips">
                <tr v-if="!Array.isArray(ip.domains) || ip.domains.length === 0">
                    <td>
                        {{ i + 1 }}
                    </td>
                    <td>
                        {{ ip.address }}
                    </td>
                    <td :class="{
                        success: ip.status && ip.status.toLowerCase() === 'online',
                        error: ip.status && ip.status.toLowerCase() === 'offline'
                    }">
                        {{ ip.status }}
                    </td>
                    <td>
                        {{ getServerName(ip.server) }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <template v-else>
                    <tr v-for="(domain, j) in ip.domains">
                        <td v-if="j === 0" :rowspan="ip.domains.length">
                            {{ i + 1 }}
                        </td>
                        <td v-if="j === 0" :rowspan="ip.domains.length">
                            {{ ip.address }}
                        </td>
                        <td
                            v-if="j === 0"
                            :rowspan="ip.domains.length"
                            :class="{
                                success: ip.status && ip.status.toLowerCase() === 'online',
                                error: ip.status && ip.status.toLowerCase() === 'offline'
                            }"
                        >
                            {{ ip.status }}
                        </td>
                        <td v-if="j === 0" :rowspan="ip.domains.length">
                            {{ getServerName(ip.server) }}
                        </td>
                        <td>
                            <a :href="`https://${domain.name}`" target="_blank">{{ domain.name_utf8 }}</a>
                        </td>
                        <td :class="{
                            success: (
                                !isNaN(domain.status_code)
                                && parseInt(domain.status_code) >= 200
                                &&  parseInt(domain.status_code) < 400),
                            error: ((isNaN(domain.status_code))
                                || (parseInt(domain.status_code) >= 400))}">
                            {{ domain.status_code }}
                        </td>
                        <td :style="{ color: domain.ssl_message.toUpperCase() === 'OK' ? 'green' : 'red' }">
                            {{ domain.ssl_message }}
                        </td>
                        <td>
                            <a
                                v-for="order in domain.non_terminated_orders"
                                :href="`/orders/${order.number}`"
                                style="display: inline-block; margin-right: 10px"
                                target="_blank"
                                :class="{ upcoming: new Date(order.start_date) > new Date() }"
                            >
                                {{ order.number }}
                            </a>
                        </td>
                    </tr>
                </template>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import 'datatables.net-responsive-dt'

export default {
    name: 'ip-domains',
    props: ['ips'],
    data: function () {
        return {};
    },
    mounted() {
        /*if (!$.fn.DataTable.isDataTable('#ips')) {
            $('#ips').DataTable({responsive: true});
        }*/
    },
    updated() {
    },
    methods: {
        getServerName(server) {
            return server.toLowerCase() === 'roi1' ? 'SERVER 1' : (server.toLowerCase() === 'roi2' ? 'SERVER 2' : server.toUpperCase());
        },
    },
    filters: {
        formatDateYmd(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        formatDate(date) {
            return moment(date).format('MMM Do HH:mm');
        }
    }
}
</script>

<style scoped>
a.upcoming, a.upcoming:hover, a.upcoming:active, a.upcoming:visited {
    color: orange;
}

.success {
    color: green;
}

.error {
    color: red;
}
</style>
